'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { MODAL_WIDTH, RequestStatus } from 'FileManagerCore/Constants';
import requestStatusProp from 'FileManagerCore/types/props/RequestStatusProp';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { removeFolder } from '../../actions/Folders';
import { closeModal } from '../../actions/Actions';
import { getNestedFolderFileCount } from '../../actions/Bulk';
import { getTotalFileCount, getTotalNestedFileCountRequestStatus } from '../../selectors/Selection';
import { jsx as _jsx } from "react/jsx-runtime";
class DeleteFolderModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      deletePending: false
    };
    this.handleConfirm = () => {
      this.setState({
        deletePending: true
      });
      this.props.closeModal();
      this.props.removeFolder(this.props.folder);
    };
  }
  componentDidMount() {
    this.props.getNestedFolderFileCount(Immutable.List.of(this.props.folder.get('id')), false);
  }
  render() {
    const {
      folder,
      totalFileCount,
      totalNestedFileCountRequestStatus
    } = this.props;
    if (totalNestedFileCountRequestStatus === RequestStatus.UNINITIALIZED || totalNestedFileCountRequestStatus === RequestStatus.PENDING) {
      return /*#__PURE__*/_jsx(UILoadingOverlay, {});
    }
    return /*#__PURE__*/_jsx(UIConfirmModal, {
      "data-test-id": "delete-folder-modal",
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.trashModal.deleteFolderConfirmLabel"
      }),
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.trashModal.cancel"
      }),
      confirmUse: "danger",
      rejectUse: "tertiary-light",
      width: MODAL_WIDTH,
      description: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "FileManagerCore.trashModal.deleteFolderDescription",
          options: {
            name: folder.get('name')
          }
        })
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: totalFileCount ? 'FileManagerCore.trashModal.deleteFolderWithFilesMessage' : 'FileManagerCore.trashModal.deleteFolderMessage',
        options: {
          count: totalFileCount
        }
      }),
      use: "danger",
      onConfirm: this.handleConfirm,
      onReject: this.props.closeModal,
      disableConfirm: this.state.deletePending
    });
  }
}
DeleteFolderModal.propTypes = {
  folder: PropTypes.instanceOf(Immutable.Map).isRequired,
  totalFileCount: PropTypes.number,
  totalNestedFileCountRequestStatus: requestStatusProp,
  removeFolder: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  getNestedFolderFileCount: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  totalFileCount: getTotalFileCount(state),
  totalNestedFileCountRequestStatus: getTotalNestedFileCountRequestStatus(state)
});
const mapDispatchToProps = {
  removeFolder,
  closeModal,
  getNestedFolderFileCount
};
export default connect(mapStateToProps, mapDispatchToProps)(DeleteFolderModal);